


































































import Vue from 'vue'
import Component from 'vue-class-component'
import { State, Action } from 'vuex-class'

import Input2PasswordInput from '../../../../../../html-components-type-1-basic/basic-type-3-input/input-2-password-input.vue'
import UserInterface3ErrorMessage from '../../../../../../html-components-type-1-basic/basic-type-4-user-interface/user-interface-3-error-message.vue'
import DigitalCurrency17AccountSignInButton from '../../../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-17-account-sign-in-button.vue'

@Component({
  components: {
    Input2PasswordInput,
    UserInterface3ErrorMessage,
    DigitalCurrency17AccountSignInButton
  }
})
class AccountInformationSettings1ServiceAccountSettings extends Vue {
  @State('serviceAccount') serviceAccount?: any

  @Action('uninitializeServiceAccount') uninitializeServiceAccount?: any

  showAreYouSureLogoutDialog: boolean = false

  showErrorMessage: boolean = false
  errorMessage: string = ''

  signOut () {
    this.uninitializeServiceAccount()
    .then(() => {
      this.showAreYouSureLogoutDialog = false
    })
    .catch((errorMessage: any) => {
      this.errorMessage = errorMessage
      this.showErrorMessage = true
    })
  }
}

export default AccountInformationSettings1ServiceAccountSettings

